import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';
import { AppConstants } from 'app/shared/constants/app.constants';
import { AuthenticationService } from 'app/authentication/service';

@Injectable({ providedIn: 'root' })
export class IdleService {
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) {}

  init() {
    this.idle.setIdle(AppConstants.SESSION_IDLE_TIME);
    this.idle.setTimeout(AppConstants.SESSION_TIMEOUT);
    this.keepalive.interval(AppConstants.SESSION_PING_TIME);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeout.subscribe(async () => {
      const Swal = (await import('sweetalert2')).default;
      Swal.close();
      this.logout();
    });

    this.idle.onIdleStart.subscribe(async () => {
      const Swal = (await import('sweetalert2')).default;
      Swal.fire({
        title: 'Extend Session',
        text: 'The Session is about to end. Do you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Extend Session',
        cancelButtonText: 'Cancel Session',
      }).then((result) => {
        if (result.isConfirmed) {
          this.reset();
        } else {
          this.logout();
        }
      });
    });

    this.keepalive.onPing.subscribe(() => {});
    this._authenticationService.currentUser.subscribe((currentUser) => {
      const isLoggedIn = currentUser && currentUser.accessToken;
      if (isLoggedIn) {
        this.idle.watch();
      } else {
        this.idle.stop();
      }
    });
  }

  reset() {
    this.idle.stop();
    this.idle.watch();
  }

  logout() {
    this._authenticationService.logout();
  }
}
